import React from 'react'
import { Link } from 'react-router-dom'
import config from '../Config'
import { t } from '../i18n'

/* Right column on desktop, bottom of Istraži (spec 4.3, 7.2). */
export default function Footer({ className = '' }) {
  return (
    <footer className={`site-footer ${className}`}>
      <nav>
        <Link to="/o-nama">{t('footer.about')}</Link>
        <Link to="/terms-of-use">{t('footer.terms')}</Link>
        <Link to="/privacy-policy.html">{t('footer.privacy')}</Link>
        <a href={`mailto:${config.CONTACT_EMAIL}`}>{t('footer.contact')}</a>
      </nav>
      <p>{t('footer.copyright')}</p>
    </footer>
  )
}
